const state = {
  jobList: {
    channels: ['whatsapp', 'voice', 'chat', 'instagram'], // string[] (slugs)
    tags: {
      contact: [], // number[]
      employer: [], // number[]
      attendance: [], // number[]
    },
    tagVisibility: {
      attendance: true,
      contact: true,
      employer: true,
    },
  },
};

export default state;
